import {
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess, 
	ifAuthenticatedOffline,
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'

import HelpdeskTicket from '@/components/modules/helpdesk/HelpdeskTicket'
import InterventionsReport from '@/components/modules/tickets/InterventionsReport'
import HelpdeskContractTabs from '@/components/modules/helpdesk/HelpdeskContractTabs'
import CarnetMovements from '@/components/modules/tickets/CarnetMovements'
import HelpdeskSettings from '@/components/modules/helpdesk/settings/HelpdeskSettings'
import HelpdeskContractsSettings from '@/components/modules/helpdesk/settings/HelpdeskContractsSettings'
import HelpdeskTariffsSettings from '@/components/modules/helpdesk/settings/HelpdeskTariffsSettings'
import SlaSettings from '@/components/modules/helpdesk/settings/SlaSettings'

export const helpdesk = [
	{
		path: '/contracts',
		redirect: '/helpdesk/contracts'
	},
	{
		path: '/contractors',
		redirect: '/helpdesk/contractors'
	},
	{
		path: '/tariffs',
		redirect: '/helpdesk/tariffs'
	},
	{
		path: '/reports',
		redirect: '/helpdesk/reports'
	},
	{
		path: '/visits',
		redirect: '/helpdesk/visits'
	},
	{
		path: '/helpdesk',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/helpdesk/',
					text: 'Service Desk',
				},
				{
					to: '/helpdesk/contracts',
					text: 'contracts',
					model: 'helpdeskcontract'
				},
				{
					to: '/helpdesk/tariffs',
					text: 'Tariffe',
					model: 'helpdesktariff'
				},
				{
					to: '/helpdesk/reports',
					text: 'Report',
					model: 'helpdeskreport'
				},
			],
		},
		children: [
			{
				path: '/helpdesk/',
				name: 'helpdesktroubles-index',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				meta: {
					title: 'troubles'
				},
				props: {
					modelDef: 'helpdesktroubles',
					actionIcon: 'mdi-face-agent',
					title: 'troubles',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/helpdesk/contracts',
				name: 'helpdeskcontracts-index',
				meta: {
					title: 'contracts',
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'helpdeskcontracts',
					actionIcon: 'library_books',
					title: 'contracts',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/helpdesk/tariffs',
				name: 'helpdesktariffs-index',
				meta: {
					title: trans('tariffs')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'helpdesktariffs',
					actionIcon: 'receipt',
					title: 'Tariffe',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/helpdesk/reports',
				meta: {
					title: trans('report')
				},				
				beforeEnter: ifAuthenticatedOnline,
				component: InterventionsReport,
				props: {
					modelDef: 'helpdeskinterventionsreports'
				}
			},
		],
	},
	{ 
		path: '/helpdesk/troubles/create',
		name: 'helpdesktroubles-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'helpdesktroubles',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},	
	{ 
		path: '/helpdesk/troubles/:id/edit',
		name: 'helpdesktroubles-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'helpdesktroubles',
			id:  parseInt(route.params.id)
		}),
	},
	{
		path: '/helpdesk/troubles/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/helpdesk/troubles/' + parseInt(route.params.id) + '/',
					text: 'Ticket',
				},
			]
		}),
		children: [
			{
				path: '',
				name: 'helpdesktroubles-show',
				beforeEnter: ifAuthenticatedOnline,
				component: HelpdeskTicket,
				meta: {
					title: 'Ticket Helpdesk'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
				}),
			},
		]
	},

	{ 
		path: '/helpdesk/contracts/create',
		name: 'helpdeskcontracts-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'helpdeskcontracts',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/helpdesk/contracts/:id/edit',
		name: 'helpdeskcontracts-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'helpdeskcontracts',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/helpdesk/contracts/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: HelpdeskContractTabs,
		props: (route) => ({
			id:  parseInt(route.params.id),
		}), 
		children: [
			{
				path: '',
				name: 'helpdeskcontracts-show', 
				beforeEnter: (to, from, next) => canAccess('permission', 'helpdeskcontract', next),
				component: Show,
				meta: {
					title: 'Contratto'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'helpdeskcontracts',
					modelClass: 'helpdeskcontract',
					activities: true,
					maillogs: true,
					fileuploader: true
				}), 
			},
			{
				path: 'troubles',
				beforeEnter: (to, from, next) => canAccess('permission', 'helpdesktrouble', next),
				component: Crud,
				meta: {
					title: 'Ticket'
				},
				props: (route) => ({
					modelDef: 'helpdesktroubles',
					actionIcon: 'location_on',
					title: 'Ticket associati',
					styleClass: 'mb-offset',
					subFilters: {contracts: parseInt(route.params.id)},
					defaultInput: {
						contract_id: parseInt(route.params.id),
						company_id: parseInt(route.query.company_id)
					}
				}),
			},
			{
				path: 'movements',
				beforeEnter: (to, from, next) => canAccess('permission', 'helpdeskcontract', next),
				component: CarnetMovements,
				meta: {
					title: 'Movimenti Ore'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					apiPrefix: 'helpdeskcontracts',
				}),
			},
		]
	},

	{ 
		path: '/helpdesk/tariffs/create',
		name: 'helpdesktariffs-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'helpdesktariffs',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/helpdesk/tariffs/:id/edit',
		name: 'helpdesktariffs-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'helpdesktariffs',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/helpdesk/tariffs/:id',
		name: 'helpdesktariffs',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '',
					text: 'Tariffario',
				},
			],
		}, 
		children: [
			{
				path: '/helpdesk/tariffs/:id',
				name: 'helpdesktariffs-show', 
				beforeEnter: (to, from, next) => canAccess('permission', 'helpdesktariff', next),
				component: Show,
				meta: {
					title: 'Tariffario'
				},				
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'helpdesktariffs',
					modelClass: 'helpdesktariff',
					activities: true,
				}), 
			},
		]
	},
	{
		path: '/settingshelpdesk/',
		name: 'settingshelpdesk',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingshelpdesk/',
					text: 'Service Desk',
				},
				{
					to: '/settingshelpdesk/contracts',
					text: 'Contratti',
				},
				{
					to: '/settingshelpdesk/tariffs',
					text: 'Tariffari',
				},
				{
					to: '/settingshelpdesk/sla',
					text: 'SLA',
				},
			],
		},
		children: [
			{
				path: '/settingshelpdesk/',
				beforeEnter: ifAuthenticatedOnline,
				component: HelpdeskSettings,
				meta: {
					title: 'Impostazioni Helpdesk'
				},
			},
			{
				path: '/settingshelpdesk/contracts',
				beforeEnter: ifAuthenticatedOnline,
				component: HelpdeskContractsSettings,
			},
			{
				path: '/settingshelpdesk/tariffs',
				beforeEnter: ifAuthenticatedOnline,
				component: HelpdeskTariffsSettings,
			},
			{
				path: '/settingshelpdesk/sla',
				beforeEnter: ifAuthenticatedOnline,
				component: SlaSettings,
				meta: {
					title: 'Impostazioni SLA'
				},
			},
		],
	},
	{ 
		path: '/settingshelpdesk/templates-helpdesktrouble/create',
		name: 'templates-helpdesktrouble-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-helpdesktrouble',
			redirect: route.params.redirect,
			defaultInput: {type: 'helpdesktrouble'},			
		}),
	},	
	{ 
		path: '/settingshelpdesk/templates-helpdesktrouble/:id/edit',
		name: 'templates-helpdesktrouble-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-helpdesktrouble',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'helpdesktrouble'},
		}), 
	},
	{ 
		path: '/settingshelpdesk/templates-helpdesktrouble/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingshelpdesk/templates-helpdesktrouble/' + parseInt(route.params.id) + '/',
					text: 'Template Ticket Helpdesk',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-helpdesktrouble-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Ticket Helpdesk'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-helpdesktrouble',
					modelClass:  'template',
					activities: true
				}), 
			},
		]
	},
	{
		path: '/settingshelpdesk/templates-helpdeskintervention/create',
		name: 'templates-helpdeskintervention-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'templates-helpdeskintervention',
			redirect: route.params.redirect,
			defaultInput: {type: 'helpdeskintervention'},
		}),
	},
	{
		path: '/settingshelpdesk/templates-helpdeskintervention/:id/edit',
		name: 'templates-helpdeskintervention-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'templates-helpdeskintervention',
			id: parseInt(route.params.id),
			defaultInput: {type: 'helpdeskintervention'},
		}),
	},
	{
		path: '/settingshelpdesk/templates-helpdeskintervention/:id',
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/settingshelpdesk/templates-helpdeskintervention/' + parseInt(route.params.id) + '/',
					text: 'Template Intervento Helpdesk',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-helpdeskintervention-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Intervento Helpdesk'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'templates-helpdeskintervention',
					modelClass: 'template',
					activities: true
				}),
			},
		]
	},
]
